import React from 'react';
import styled from 'styled-components';
import Container from 'components/Container';
import { Box, Grid } from '@material-ui/core';
import { Hollow, hollowColorType } from 'components/Buttons';
import { Title, Text } from 'components/Texts';
import ErrorImage from 'assets/image-register-not-available.svg';
import { weight } from 'globalStyle';
import { Modal } from '../../../../../../../components/Modals/Modal';
import ModalContent from '../../../../../../../components/Modals/ModalContent';

export default function RegisterNotAvailable({ open, onClose, zIndex }) {
  return (
    <Modal wrap isBackground isOpen={open} handleClick={onClose} zIndex={zIndex} top="0px">
      <ModalContent width="325px" height="457px" onClose={onClose}>
        <Container>
          <HeaderImg
            alt=""
            src={ErrorImage}
          />
          <Grid container direction="column" alignItems="center">
            <Title isCenter size={16} width="238px">Estamos preparando una mejor experiencia para ti.</Title>
            <Text isCenter weight={weight.BOLD} size={13} lineHeight={1.37} mt={25} mb={24} width="238px">
              Regístrate en nuestra lista de espera y sé el primero
              en acceder a nuevas oportunidades de inverión.
            </Text>
            <Box width="220px">
              <Hollow
                actived
                isSubmit
                fullWidth
                size={15}
                padding="14px"
                onColorType={hollowColorType.primary}
                onClick={() => {
                  window.open('https://docs.google.com/forms/d/e/1FAIpQLSeIf_mCM9SMI8tpY0Zwvp0B_GV_XqfJZGd6u3nm9Wrz0yMIow/viewform', '_blank');
                }}
              >
                Registrate
              </Hollow>
            </Box>
          </Grid>
        </Container>
      </ModalContent>
    </Modal>
  );
}

const HeaderImg = styled.img`
  width: 122px;
  height: 124px;
  align-self: center;
  margin-top: 10px;
  margin-bottom: 25px;
`;
